import { render, staticRenderFns } from "./EFranquiaSnippetCard.vue?vue&type=template&id=e630b1dc&scoped=true&"
import script from "./EFranquiaSnippetCard.vue?vue&type=script&lang=js&"
export * from "./EFranquiaSnippetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e630b1dc",
  null
  
)

export default component.exports